import getUserInfo from '@/common/utils/getUserInfo'

const navToConsultant = (e, params) => {
        wx.navigateTo({
            url: `/consultants/card/main?${params}`
        })
}

export default {
    methods: {
        goCard (e) {
            const { id } = e.currentTarget.dataset
            navToConsultant(e, `id=${id}`)
        },
        goCardFromExcellenct (e) {
            const { id } = e.currentTarget.dataset
            navToConsultant(e, `id=${id}&from=excellent_consultants`)
        }
    }
}
